import * as React from "react";
import { useTranslation } from "react-i18next";
import { FunctionComponent } from "react";

//MUI Icons
import CloseIcon from "@mui/icons-material/Close";

//Custom Components
import CardActionButton from "@/ui/Card/CardActionButton";

//Types
import { ICardActionButtonDetail } from "@/@types/ui/Card";

const CardActionButtonClose: FunctionComponent<ICardActionButtonDetail> = (props) => {
  const { t } = useTranslation();

  return (
    <CardActionButton startIcon={<CloseIcon />} {...props} ariaLabel="Close" ariaControls="Close">
      {t("buttons.close")}
    </CardActionButton>
  );
};

export default CardActionButtonClose;
